// extracted by mini-css-extract-plugin
export var acitonButtons = "_37-0";
export var additionalIcon = "_37-f";
export var block = "_37-1";
export var blockContent = "_37-7";
export var blockDescription = "_37-8";
export var blockIcon = "_37-9";
export var blockTitle = "_37-6";
export var border = "_37-a";
export var center = "_37-l";
export var edge = "_37-b";
export var edgeLabel = "_37-c";
export var edgePath = "_37-d";
export var error = "_37-e";
export var flowchart = "_37-g";
export var flowchartContent = "_37-h";
export var highlighted = "_37-3";
export var hover = "_37-4";
export var icon = "_37-i";
export var left = "_37-m";
export var navButton = "_37-j";
export var navButtons = "_37-k";
export var right = "_37-n";
export var selected = "_37-2";
export var small = "_37-5";